import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast, ToastContainer } from "../../utils/toast";

const ContactForm = () => {
    const initialValues = {
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
    };

    const validationSchema = Yup.object({
        name: Yup.string().min(3, "Minimum 3 characters required").required("Full Name is required"),
        email: Yup.string().email("Invalid email address").required("Email is required"),
        phone: Yup.string().matches(/^\d{10}$/, "Phone must be exactly 10 digits").required("Phone is required"),
        subject: Yup.string().required("Subject is required"),
        message: Yup.string().min(10, "Minimum 10 characters required").required("Message is required"),
    });

    const handleSubmit = async (values, { resetForm, setSubmitting }) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_APP_DOMAIN}/api/customer/contact/store`,
                values
            );

            if (response.data.status === true) {
                toast.success(response.data.message || "Message sent successfully!");
                resetForm();
            } else {
                toast.error(response.data.message || "Something went wrong");
            }
        } catch (error) {
            toast.error("Server error. Please try again later.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting }) => (
                    <Form id="contactForm">
                        <div className="row">
                            <div className="col-lg-12 mb-1">
                                <label className="form-label">Full Name*</label>
                                <Field type="text" name="name" className="form-control" />
                                <ErrorMessage name="name" component="div" className="text-danger small" />
                            </div>

                            <div className="col-lg-12 mb-1">
                                <label className="form-label">Email Address*</label>
                                <Field type="text" name="email" className="form-control" />
                                <ErrorMessage name="email" component="div" className="text-danger small" />
                            </div>

                            <div className="col-lg-6 mb-1">
                                <label className="form-label">Phone*</label>
                                <Field type="text" name="phone" className="form-control" />
                                <ErrorMessage name="phone" component="div" className="text-danger small" />
                            </div>

                            <div className="col-lg-6 mb-1">
                                <label className="form-label">Select Subject*</label>
                                <Field as="select" name="subject" className="form-control">
                                    <option value="">Select</option>
                                    <option value="General">General</option>
                                    <option value="Ride">Ride</option>
                                    <option value="Partner">Partner</option>
                                    <option value="Other">Other</option>
                                </Field>
                                <ErrorMessage name="subject" component="div" className="text-danger small" />
                            </div>

                            <div className="col-lg-12 mb-1">
                                <label className="form-label">Message*</label>
                                <Field as="textarea" name="message" rows="5" className="form-control" />
                                <ErrorMessage name="message" component="div" className="text-danger small" />
                            </div>

                            <div className="col-12 text-center">
                                <button
                                    type="submit"
                                    className="btn btn-primary px-5 py-2"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm me-2"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                            Submitting...
                                        </>
                                    ) : (
                                        "Submit"
                                    )}
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
            <ToastContainer />
        </>
    );
};

export default ContactForm;
